import React, { useState, createRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import CardContainer from '../../components/card/card-container.jsx';
import ListToolbar, { BtnNuevo, BtnSecundario, BtnEliminar } from '../../nuup/componentes/Toolbar/ListToolbar.jsx';
import LabelCategory from '../../components/label/label-category.jsx';
import LabelNumber from '../../components/label/label-number.jsx';
import LabelSimple from '../../components/label/label-simple.jsx';
import Api from '../../api/global.service';
import { useAuth } from '../../components/content/auth.jsx';
import { useHistory } from 'react-router-dom';
import env from '../../environment.js';
import Swal from 'sweetalert2';
import SelectColumnFilter from '../../components/selectColumnFilter/SelectColumnFilter.js';
import SelectCiclo from '../../components/select/select-ciclo.jsx';
import SearchColumn from '../../components/search/search-column.jsx';
import CuentasListExport from './cuentas-list-export.js';
import { useCoopConfig } from '../../components/content/coop-config.jsx';
import transformWord from '../../utils/transformWord.js';
import NoPagination from '../../components/pagination/noPagination.jsx';
import ModalCuentasBajas from '../../components/modal/modal-cuentas-bajas.jsx';
import useEtiquetas from '../../hooks/useEtiquetas.jsx';
import insertIf from '../../utils/insertIf.js';
import isEmpty from '../../utils/isEmpty.js';
import { Colors } from '../../constants/Colors.js';

const CuentasList = () => {
  const auth = useAuth();
  const history = useHistory();
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [ciclo, setCiclo] = useState({});
  const [blocking, setBlocking] = useState(true);
  const coopConfig = useCoopConfig();
  const { etiquetas } = useEtiquetas();
  const [selectedData, setSelectedData] = useState({});
  const dialog = createRef();
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);

  // Header: transformWord(coopConfig.config.parcelas_etiqueta, ['plural', 'uppercase']),
  const columns = React.useMemo(
    () => [
      {
        Header: '',
        id: 'id',
        accessor: 'x',
        width: 25,
        Cell: ({ row }) => {
          return (
            <div className="form-check">
              <input
                className="form-check-input"
                name="productores"
                type="checkbox"
                style={{
                  width: 20,
                  height: 20,
                  accentColor: Colors.primary_600,
                }}
                value={row.original.id}
                onChange={e => {
                  setSelectedData(() => {
                    return e.target.checked ? row.original : {};
                  });
                }}
                checked={(selectedData?.id === row.original.id) === true}
              />
            </div>
          );
        },
      },
      {
        Header: 'CLAVE',
        accessor: 'clave_tx',
        sortable: true,
        minWidth: 60,
      },
      {
        Header: 'CÓDIGO',
        accessor: 'codigo_tx',
        sortable: true,
        minWidth: 80,
        show: !!+coopConfig.config?.usa_codigo_tx,
      },
      {
        Header: 'NOMBRE PRODUCTOR',
        accessor: 'nombre',
        sortable: true,
        Cell: ({ value, row }) => (
          <Link to={{ pathname: `/admin/cuentas/perfil/${row.original.uuid}` }} className="m-r-2" style={{ color: '#789D16' }}>
            <span>{value}</span>
          </Link>
        ),
      },
      {
        Header: 'REGIÓN',
        accessor: 'cuenta_region',
        sortable: true,
      },
      {
        Header: 'MUNICIPIO',
        accessor: 'municipio',
        sortable: true,
      },
      {
        Header: 'COMUNIDAD',
        accessor: 'localidad',
        sortable: true,
      },
      {
        Header: 'CATEGORÍA',
        accessor: 'cuenta_categoria',
        sortable: true,
        Cell: ({ value, row }) => <LabelCategory label={value} color={row.original.cuenta_categoria_color}></LabelCategory>,
        minWidth: 90,
      },
      {
        Header: 'N° F. SIC',
        accessor: 'total_tx_sic',
        sortable: true,
        minWidth: 30,
        show: !!+coopConfig.config?.usa_sic,
        Cell: ({ value }) => {
          return <LabelNumber value={value}></LabelNumber>;
        },
        Filter: SelectColumnFilter,
        filter: 'equals',
      },
      {
        Header: 'N° REPORTES EXTRAS',
        accessor: 'total_r_extras',
        sortable: true,
        minWidth: 30,
        show: !!+coopConfig.config?.usa_sic,
        Cell: ({ value }) => {
          return <LabelNumber value={value}></LabelNumber>;
        },
        Filter: SelectColumnFilter,
        filter: 'equals',
      },
      {
        Header: 'N° ' + transformWord(etiquetas?.parcela, ['plural', 'uppercase']),
        accessor: 'total_parcelas',
        sortable: true,
        minWidth: 60,
        Cell: ({ value }) => {
          return <LabelNumber value={value}></LabelNumber>;
        },
        Filter: SelectColumnFilter,
        filter: 'equals',
      },
      {
        Header: 'N° ' + transformWord(etiquetas?.planta, ['plural', 'uppercase']),
        accessor: 'total_plantas',
        sortable: true,
        minWidth: 60,
        show: +coopConfig.config?.cooperativa?.producto?.id === env.productos.MIEL,
        Cell: ({ value }) => {
          return <LabelNumber value={value}></LabelNumber>;
        },
        Filter: SelectColumnFilter,
        filter: 'equals',
      },
      {
        Header: 'CICLO',
        accessor: 'ciclo',
        sortable: true,
        minWidth: 60,
        Cell: ({ value }) => {
          return (
            <p className="text-right" style={{ margin: 0 }}>
              {value}
            </p>
          );
        },
      },
      {
        Header: 'EN PADRÓN',
        accessor: 'organico',
        sortable: true,
        Cell: ({ value }) => {
          return (
            <LabelSimple
              label={value == 1 ? 'Sí' : 'No'}
              bgColor={value == 1 ? Colors.primary_600 + '22' : Colors.neutral_200}></LabelSimple>
          );
        },
      },
      {
        Header: 'PERTENECE A LA ORGANIZACIÓN',
        accessor: 'pertenece_cooperativa',
        sortable: true,
        Cell: ({ value }) => {
          return (
            <LabelSimple
              label={value == 1 ? 'Sí' : 'No'}
              bgColor={value == 1 ? Colors.primary_600 + '22' : Colors.neutral_200}></LabelSimple>
          );
        },
      },
    ],
    [coopConfig, etiquetas, selectedData]
  );

  const searchColumns = React.useMemo(
    () => [
      { value: 0, target: '', label: 'TODO' },
      { value: 1, target: 'clave_tx', label: 'CLAVE' },
      ...insertIf(+coopConfig.config?.usa_codigo_tx, {
        value: 2,
        target: 'codigo_tx',
        label: 'CÓDIGO',
      }),
      { value: 3, target: 'nombre', label: 'PRODUCTOR' },
      { value: 4, target: 'cuenta_region', label: 'REGIÓN' },
      { value: 5, target: 'municipio', label: 'MUNICIPIO' },
      { value: 6, target: 'localidad', label: 'COMUNIDAD' },
      { value: 7, target: 'cuenta_categoria', label: 'CATEGORÍA' },
      ...insertIf(+coopConfig.config?.usa_sic, {
        value: 8,
        target: 'total_tx_sic',
        label: 'N° F. SIC',
      }),
      ...insertIf(+coopConfig.config?.usa_sic, {
        value: 9,
        target: 'total_tx_po',
        label: 'N° F. PO',
      }),
      {
        value: 10,
        target: 'total_parcelas',
        label: `N° ${transformWord(etiquetas?.parcela, ['plural', 'uppercase'])}`,
      },
      { value: 11, target: 'ciclo', label: 'CICLO' },
      { value: 11, target: 'organico', label: 'EN PADRÓN' },
      {
        value: 11,
        target: 'pertenece_cooperativa',
        label: 'PERTENECE A LA ORGANIZACIÓN',
      },
    ],
    [etiquetas]
  );

  const setFilter = value => {
    setCiclo(value.target);

    setBlocking(true);
    Api.search('cuentas', {
      filter: [
        { column: 'id_ciclo', operator: '=', value: value.target.id },
        { column: 'confirmado', operator: '=', value: 1 },
      ],
      sort: [{ column: 'clave_tx', sort: 'asc' }],
    })
      .then(response => {
        response.data = response.data.map(function(item, i) {
          return {
            ...item,
            _no: i + 1,
          };
        });
        //filter data by params
        let filteredData = response.data;
        if (urlParams.get('organico')) {
          filteredData = response.data.filter(d => d.organico == urlParams.get('organico'));
        }
        setData(filteredData);
        setOriginalData(filteredData);
        setBlocking(false);
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.log('e', e);
        setBlocking(false);
      });
  };

  const setDataFilter = data => {
    setData(data);
  };

  const eliminarProductor = razonBaja => {
    Swal.fire({
      title: `El productor ${selectedData.nombre} se dará de baja`,
      text: `Esta acción es de forma permanente`,
      showCancelButton: true,
      confirmButtonText: 'Dar de baja',
      confirmButtonColor: '#FF5733',
      cancelButtonText: 'Cancelar',
      cancelButtonColor: '#f4f4f4',
      customClass: {
        confirmButton: 'text-white',
      },
    }).then(result => {
      if (result.isConfirmed) {
        // closing the modal
        dialog.current.close();
        // prep data
        const bajaData = {
          ...razonBaja,
          id_cuenta: selectedData.id,
          id_ciclo: ciclo.id,
        };
        // post to API
        Api.create('admin/sic/listado_bajas', bajaData)
          .then(response => {
            const { success, message } = response.data;
            if (success === 1) {
              Swal.fire({
                icon: 'success',
                title: '',
                text: `El productor ha sido dado de baja`,
                confirmButtonText: 'Continuar',
                confirmButtonColor: '#FFB94C',
              }).then(result => {
                if (result.isConfirmed) {
                  //window.location.href = `/admin/cuentas/list`;
                  setFilter({ target: ciclo });
                }
              });
            } else {
              Swal.fire({
                icon: 'error',
                title: '',
                text: message,
                showDenyButton: true,
                denyButtonText: `Regresar a listado de productores`,
              }).then(result => {
                if (result.isDenied) {
                  // eslint-disable-next-line no-console
                  console.log('response.data', response.data);
                }
              });
            }
          })
          .catch(error => {
            // eslint-disable-next-line no-console
            console.log('error', error);
            Swal.fire({
              icon: 'error',
              title: '',
              text: error.response?.data?.message,
            });
          });
      }
    });
  };

  return (
    <div>
      <div className="row justify-content-between">
        <SelectCiclo
          setFilter={evt => {
            setFilter(evt);
          }}></SelectCiclo>

        <div className="col-8 d-flex justify-content-end">
          {ciclo?.uuid && auth.hasPermission('CUENTAS_EXPORTAR') && (
            <div style={{ alignSelf: 'center', marginBottom: 12, marginLeft: 12 }}>
              {data.length > 0 && (
                <Link
                  to="#"
                  onClick={() =>
                    CuentasListExport(
                      data,
                      coopConfig?.config?.cooperativa?.nombre,
                      transformWord(etiquetas?.parcela, ['plural', 'uppercase']),
                      +coopConfig.config?.cooperativa?.producto?.id === env.productos.MIEL
                        ? transformWord(etiquetas?.planta, ['plural', 'uppercase'])
                        : ''
                    )
                  }
                  className="m-r-2"
                  style={{ color: '#789D16' }}>
                  <img src={env.images.icon.xls} className="pr-1" /> <span>Descargar Excel</span>
                </Link>
              )}
            </div>
          )}
        </div>
      </div>

      <CardContainer height={'100%'}>
        <ListToolbar left={<SearchColumn data={originalData} columns={searchColumns} setDataFilter={evt => setDataFilter(evt)} />}>
          <BtnNuevo
            show={auth.hasPermission('ACOPIOS_ENTREGAS_X_PRODUCTOR_NUEVO')}
            onClick={() =>
              history.push(`/admin/cuentas/agregar`, {
                redirect: '/admin/cuentas/list',
              })
            }>
            Nuevo productor
          </BtnNuevo>
          <BtnSecundario
            onClick={() =>
              history.push(`/admin/cuentas/editar/${selectedData?.uuid}`, {
                redirect: '/admin/cuentas/list',
              })
            }
            disabled={isEmpty(selectedData)}>
            Editar
          </BtnSecundario>
          <BtnEliminar onClick={() => dialog.current.open()} disabled={isEmpty(selectedData)}>
            Dar de baja
          </BtnEliminar>
        </ListToolbar>

        <NoPagination blocking={blocking} columns={columns} data={data}></NoPagination>
        <ModalCuentasBajas
          ref={dialog}
          title="Dar de baja al productor"
          onConfirm={razonBaja => eliminarProductor(razonBaja)}></ModalCuentasBajas>
      </CardContainer>
    </div>
  );
};

export default CuentasList;
